import { type I18n, i18n as i18nCore, setupI18n } from '@lingui/core';
// @ts-expect-error wrong type in message-utils
import { compileMessage } from '@lingui/message-utils/compileMessage';

function configureI18n(i18n: I18n) {
  i18n.setMessagesCompiler(compileMessage);
  i18n.load({ en: {} });
  i18n.activate('en');
}

export function i18nInit() {
  const i18n = setupI18n();

  configureI18n(i18n);
  configureI18n(i18nCore);

  return i18n;
}
